export const AXIS = "axis";
export const VALUE = "value";

export const ASC = "asc";
export const DESC = "desc";
